<template>
  <div class="Accordion">
    <slot/>
  </div>
</template>

<script>
export default {
  provide () {
    return {
      accordionOptions: this.accordionOptions
    }
  },
  data () {
    return {
      accordionOptions: {
        current: null
      }
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
